var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "author-card-c", attrs: { "data-spm": "author" } },
    [
      _c("a", { attrs: { href: _vm.authorInfo.personalPage } }, [
        _c("img", { attrs: { src: _vm.authorInfo.logo } }),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c("div", { staticClass: "name" }, [
            _vm._v(_vm._s(_vm.authorInfo.name) + "\n        "),
            _vm.showRedVipMark
              ? _c("div", { staticClass: "vip-logo-red" })
              : _vm.showYellowVipMark
              ? _c("div", { staticClass: "vip-logo-yellow" })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "count" }, [
            _c("span", { staticClass: "title" }, [_vm._v("文章")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.formatCount(_vm.authorInfo.articleCount))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "line" }),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [_vm._v("总阅读")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.formatCount(_vm.pvCount)))]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }